export default function Footer() {
  return (
    <span
      style={{ letterSpacing: "3px", color: "#cacaca" }}
    >{`EuroCup ${new Date().getFullYear()}`}</span>
  );
}
